/**
 * Created by afuhr on 20.09.2016.
 */
import {TypedRecord} from "typed-immutable-record";
import {IModel} from "../../view-model/imodel.interface";
import {AdministrationUnit} from "../../view-model/organization/administration-unit.type";
import {List} from "immutable";
import {TypedList} from "../typed-list";

export interface IUser extends IModel {
  name?: string;
  pre_name?: string;
  email?: string;
  form_of_address?: string;
  academic_title?: string;
  is_deactivated?: boolean;
  customer_id?: null;
  administration_units?: AdministrationUnit[];
  permissions?: string[];
  roles?: string[];
}

export interface IUserRecord extends TypedRecord<IUserRecord>, IUser {
}

export interface ISession {
  token: string;
  loggedIn: boolean;
  hasError: boolean;
  isLoading: boolean;
  redirectUrl: string;
  user: IUser;
  activeAdminUnit: string;
  activeAdminUnitData: AdministrationUnit;
  messages: List<Message>;
}

export interface ISessionRecord extends TypedRecord<ISessionRecord>, ISession {
}

export interface IAdminUnitRecord extends TypedRecord<IAdminUnitRecord>, AdministrationUnit {
}

export interface Message {
  type: MessageType;
  message: string;
}

export interface MessageRecord extends TypedRecord<MessageRecord>, Message {
}

export interface MessageList extends TypedList<MessageList>, Message {
}


export enum MessageType {
  WARNING, INFO, ERROR, SUCCESS
}



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/session/session.types.ts